// Países atendidos (INTERNACIONALIZACAO_EUA_PLAN.md §3.4). Mesmo conteúdo de
// zaper-api/config/paises.php e zaper-comandas/src/utils/paises.js.
// Código desconhecido ou vazio cai no Brasil: é o que toda loja existente é.

export const PAIS_PADRAO = 'BR';

export const PAISES = {
    BR: {
        codigo: 'BR',
        nome: { 'pt-BR': 'Brasil', en: 'Brazil' },
        ddi: '55',
        moeda: 'BRL',
        idioma: 'pt-BR',
        timezone: 'America/Sao_Paulo',
        telefone: { min: 10, max: 11, mascara: ['(##) ####-####', '(##) #####-####'], exemplo: '(99) 99999-9999' },
        codigoPostal: { mascara: '#####-###', regex: /^\d{5}-?\d{3}$/, digitos: 8 },
        unidadeDistancia: 'km',
    },
    US: {
        codigo: 'US',
        nome: { 'pt-BR': 'Estados Unidos', en: 'United States' },
        ddi: '1',
        moeda: 'USD',
        idioma: 'en',
        timezone: 'America/New_York',
        telefone: { min: 10, max: 10, mascara: ['(###) ###-####'], exemplo: '(212) 555-1234' },
        codigoPostal: { mascara: '#####', regex: /^\d{5}$/, digitos: 5 },
        unidadeDistancia: 'mi',
    },
};

export const pais = codigo => PAISES[String(codigo || '').toUpperCase()] || PAISES[PAIS_PADRAO];

export const isBrasil = codigo => pais(codigo).codigo === PAIS_PADRAO;

/** Telefone com a quantidade de dígitos do país do DDI (sem DDI = Brasil). */
export const telefoneValido = (numero, ddi) => {
    const { min, max } = paisDoDdi(ddi || PAISES[PAIS_PADRAO].ddi).telefone;
    const digitos = String(numero || '').replace(/\D/g, '');

    return digitos.length >= min && digitos.length <= max;
};

/** Número com DDI para link do WhatsApp (wa.me / api.whatsapp.com). */
export const telefoneInternacional = (numero, ddi) => `${ddi || PAISES[PAIS_PADRAO].ddi}${String(numero || '').replace(/\D/g, '')}`;

export const paisDoDdi = ddi => Object.values(PAISES).find(p => p.ddi === String(ddi || '')) || PAISES[PAIS_PADRAO];

/** CEP (8 dígitos) ou ZIP (5), conforme o país da loja. */
export const codigoPostalValido = (valor, codigo) =>
    String(valor || '').replace(/\D/g, '').length === pais(codigo).codigoPostal.digitos;
